export default function responseErrorFilter(error) {
  // eslint-disable-next-line no-console
  console.log(error.response?.data?.message ?? error.response ?? error);
  return error.response?.data?.message ?? error.response ?? error;
}
